var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import { Close } from '@otp/icons';
import { Typography } from '../typography';
import { Delimiter } from '../delimiter';
export const Modal = (_a) => {
    var { open, onClose, title, children, actions } = _a, props = __rest(_a, ["open", "onClose", "title", "children", "actions"]);
    return (_jsxs(Dialog, Object.assign({ open: open, onClose: onClose }, props, { children: [_jsxs(DialogTitle, { sx: { paddingBottom: 0 }, children: [_jsx(Typography, { variant: "subtitle1", sx: { marginBottom: 2 }, children: title }), _jsx(Delimiter, {})] }), _jsx(IconButton, { "aria-label": "close", onClick: onClose, sx: {
                    position: 'absolute',
                    right: 16,
                    top: 16,
                    color: (theme) => theme.palette.grey[600],
                }, children: _jsx(Close, {}) }), _jsx(DialogContent, { children: children }), _jsx(DialogActions, { sx: { paddingRight: 4, paddingBottom: 3 }, children: actions === null || actions === void 0 ? void 0 : actions.map((action, index) => _jsx("div", { children: action }, index)) })] })));
};
